import 'es6-promise/auto';
import 'core-js/stable';
import EventRegisterButton from "./components/EventRegisterButton.vue";

import Vue from 'vue';

document.querySelectorAll(".event-register-button-container").forEach(el => {
    new Vue({
        el,
        components: { EventRegisterButton }
    });
});